import { useEffect } from "react";

// Lightweight client-side SEO head manager (CRA has no SSR).
// Sets title, meta description, canonical, OpenGraph, Twitter cards and
// an optional NewsArticle JSON-LD block. Cleans up injected tags on unmount.
function setMeta(attr, key, content) {
  if (content == null) return null;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const created = !el;
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
  return { el, created };
}

export function Seo({ title, description, image, url, type = "article", article, jsonLd }) {
  useEffect(() => {
    const prevTitle = document.title;
    const managed = [];
    if (title) document.title = title;

    const canonicalUrl = url || window.location.href;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    const canonicalCreated = !canonical;
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    const prevCanonical = canonical.getAttribute("href");
    canonical.setAttribute("href", canonicalUrl);

    const push = (r) => { if (r) managed.push(r); };
    push(setMeta("name", "description", description));
    push(setMeta("property", "og:title", title));
    push(setMeta("property", "og:description", description));
    push(setMeta("property", "og:type", type));
    push(setMeta("property", "og:url", canonicalUrl));
    push(setMeta("property", "og:image", image));
    push(setMeta("property", "og:site_name", "OnchainLyfe"));
    push(setMeta("name", "twitter:card", image ? "summary_large_image" : "summary"));
    push(setMeta("name", "twitter:title", title));
    push(setMeta("name", "twitter:description", description));
    push(setMeta("name", "twitter:image", image));
    if (article?.published) push(setMeta("property", "article:published_time", article.published));
    if (article?.modified) push(setMeta("property", "article:modified_time", article.modified));
    if (article?.section) push(setMeta("property", "article:section", article.section));

    let ld;
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.setAttribute("data-seo", "jsonld");
      ld.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ld);
    }

    return () => {
      document.title = prevTitle;
      managed.forEach(({ el, created }) => { if (created && el.parentNode) el.parentNode.removeChild(el); });
      if (canonicalCreated && canonical.parentNode) canonical.parentNode.removeChild(canonical);
      else if (prevCanonical != null) canonical.setAttribute("href", prevCanonical);
      if (ld && ld.parentNode) ld.parentNode.removeChild(ld);
    };
  }, [title, description, image, url, type, JSON.stringify(article), JSON.stringify(jsonLd)]);

  return null;
}
